// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jdprzuP,.jdprzuP[class*=Button],button.jdprzuP{height:initial;font-size:16px;font-weight:600;border:initial;background:initial}@media(min-width: 600px){.jdprzuP,.jdprzuP[class*=Button],button.jdprzuP{font-size:18px}}.jdprzuP:hover,.jdprzuP[class*=Button]:hover,button.jdprzuP:hover{background:initial}.QfYNpQc{padding-top:.15em;padding-left:.4em}@media(min-width: 600px){.QfYNpQc{padding-top:.27em}}.SVq_cLG{width:24px;height:24px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `jdprzuP`,
	"title": `QfYNpQc`,
	"icon": `SVq_cLG`
};
export default ___CSS_LOADER_EXPORT___;
